import { Component, OnInit, ViewChild, ViewEncapsulation, TemplateRef } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryComponent } from 'ngx-gallery';
import { Title, Meta} from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-district',
  templateUrl: './district.component.html',
  styleUrls: ['./district.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class DistrictComponent implements OnInit {

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  slides: Array<any>;

  modalRef: BsModalRef;

  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false
  };

  @ViewChild('districtGallery') districtGallery: NgxGalleryComponent;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private modalService: BsModalService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {

    this.slides = [
      {
        url: '../../assets/img/district/jogging.jpg',
        description: 'Go jogging on the Banks of the Seine'
      },
      {
        url: '../../assets/img/district/old-town-hall.jpg',
        description: '”local history museum“ in the old Town hall'
      },
      {
        url: '../../assets/img/district/maison-la-fournaise.jpg',
        description: 'Restaurant ”Maison de la Fournaise“'
      },
      {
        url: '../../assets/img/district/la-patio-shopping.jpg',
        description: '”la patio“ shopping center'
      },
      {
        url: '../../assets/img/district/chateau-malmaison.jpg',
        description: 'Château de Malmaison'
      },
      {
        url: '../../assets/img/district/green-district.jpg',
        description: 'A green district'
      },
      {
        url: '../../assets/img/district/the-duke.jpg',
        description: 'Restaurant ”The Duke“'
      },
      {
        url: '../../assets/img/district/banks-seine.jpg',
        description: 'Banks of the Seine'
      },
      {
        url: '../../assets/img/district/impressionist-park.jpg',
        description: 'Impressionist’s park'
      },
      {
        url: '../../assets/img/district/rives-la-courtille.jpg',
        description: 'Restaurant “Les rives de la courtille”'
      },
      {
        url: '../../assets/img/district/park-friendship.jpg',
        description: 'Park of the friendship'
      }
    ];

    if (this.translate.currentLang === 'en') {
      this.titleService.setTitle('Voyager - Location and access');
      this.metaService.addTags([
        { name: 'description', content: 'Rueil Malmaison stands at the heart of a uniquely vibrant business hub with many CAC40 companies. The city offers a superb living and working environment.' },
        { name: 'keywords', content: 'Rueil-Malmaison, business hub, CAC40, rueil-sur-seine, garden, green space' }
      ]);
    } else if (this.translate.currentLang === 'fr'){
      this.titleService.setTitle('Voyager - Un quartier d\'affaire au coeur de Rueil-Malmaison');
      this.metaService.addTags([
        { name: 'description', content: 'Rueil Malmaison est un quartier d\'affaires qui accueillent les entreprises du CAC40. Le quartier s\'anime à travers des espaces culturels et de nombreux restaurants, le tout entouré d\'espaces verts.' },
        { name: 'keywords', content: 'Rueil-Malmaison, quartier des affaires, entreprises, CAC40, restaurants, culture' }
      ]);
    }


    this.galleryImages = [
      {
        small: '../../assets/img/district/jogging.jpg',
        medium: '../../assets/img/district/jogging.jpg',
        big: '../../assets/img/district/jogging.jpg',
        description: 'Go jogging on the Banks of the Seine'

      },
      {
        small: '../../assets/img/district/old-town-hall.jpg',
        medium: '../../assets/img/district/old-town-hall.jpg',
        big: '../../assets/img/district/old-town-hall.jpg',
        description: '”local history museum“ in the old Town hall'

      },
      {
        small: '../../assets/img/district/maison-la-fournaise.jpg',
        medium: '../../assets/img/district/maison-la-fournaise.jpg',
        big: '../../assets/img/district/maison-la-fournaise.jpg',
        description: 'Restaurant ”Maison de la Fournaise“'

      },
      {
        small: '../../assets/img/district/la-patio-shopping.jpg',
        medium: '../../assets/img/district/la-patio-shopping.jpg',
        big: '../../assets/img/district/la-patio-shopping.jpg',
        description: '”La Patio“ shopping center'

      },
      {
        small: '../../assets/img/district/chateau-malmaison.jpg',
        medium: '../../assets/img/district/chateau-malmaison.jpg',
        big: '../../assets/img/district/chateau-malmaison.jpg',
        description: 'Château de Malmaison'

      },
      {
        small: '../../assets/img/district/green-district.jpg',
        medium: '../../assets/img/district/green-district.jpg',
        big: '../../assets/img/district/green-district.jpg',
        description: 'A green district'

      },
      {
        small: '../../assets/img/district/the-duke.jpg',
        medium: '../../assets/img/district/the-duke.jpg',
        big: '../../assets/img/district/the-duke.jpg',
        description: 'Restaurant ”The Duke“'

      },
      {
        small: '../../assets/img/district/banks-seine.jpg',
        medium: '../../assets/img/district/banks-seine.jpg',
        big: '../../assets/img/district/banks-seine.jpg',
        description: 'Banks of the Seine'

      },
      {
        small: '../../assets/img/district/impressionist-park.jpg',
        medium: '../../assets/img/district/impressionist-park.jpg',
        big: '../../assets/img/district/impressionist-park.jpg',
        description: 'Impressionist’s park'

      },
      {
        small: '../../assets/img/district/rives-la-courtille.jpg',
        medium: '../../assets/img/district/rives-la-courtille.jpg',
        big: '../../assets/img/district/rives-la-courtille.jpg',
        description: 'Restaurant “Les rives de la courtille”'

      },
      {
        small: '../../assets/img/district/park-friendship.jpg',
        medium: '../../assets/img/district/park-friendship.jpg',
        big: '../../assets/img/district/park-friendship.jpg',
        description: 'Park of the friendship'

      }
    ];

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (this.translate.currentLang === 'en') {
        this.titleService.setTitle('Voyager - Location and access');
        this.metaService.updateTag({
          name: 'description',
          content: 'Rueil Malmaison stands at the heart of a uniquely vibrant business hub with many CAC40 companies. The city offers a superb living and working environment.'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Rueil-Malmaison, Business hub, CAC40, rueil-sur-seine, garden, green space'
        });

        this.slides = [
          {
            url: '../../assets/img/district/jogging.jpg',
            description: 'Go jogging on the Banks of the Seine'
          },
          {
            url: '../../assets/img/district/old-town-hall.jpg',
            description: '”local history museum“ in the old Town hall'
          },
          {
            url: '../../assets/img/district/maison-la-fournaise.jpg',
            description: 'Restaurant ”Maison de la Fournaise“'
          },
          {
            url: '../../assets/img/district/la-patio-shopping.jpg',
            description: '”la patio“ shopping center'
          },
          {
            url: '../../assets/img/district/chateau-malmaison.jpg',
            description: 'Château de Malmaison'
          },
          {
            url: '../../assets/img/district/green-district.jpg',
            description: 'A green district'
          },
          {
            url: '../../assets/img/district/the-duke.jpg',
            description: 'Restaurant ”The Duke“'
          },
          {
            url: '../../assets/img/district/banks-seine.jpg',
            description: 'Banks of the Seine'
          },
          {
            url: '../../assets/img/district/impressionist-park.jpg',
            description: 'Impressionist’s park'
          },
          {
            url: '../../assets/img/district/rives-la-courtille.jpg',
            description: 'Restaurant “Les rives de la courtille”'
          },
          {
            url: '../../assets/img/district/park-friendship.jpg',
            description: 'Park of the friendship'
          }
        ];

        this.galleryImages = [
          {
            small: '../../assets/img/district/jogging.jpg',
            medium: '../../assets/img/district/jogging.jpg',
            big: '../../assets/img/district/jogging.jpg',
            description: 'Go jogging on the Banks of the Seine'

          },
          {
            small: '../../assets/img/district/old-town-hall.jpg',
            medium: '../../assets/img/district/old-town-hall.jpg',
            big: '../../assets/img/district/old-town-hall.jpg',
            description: '”local history museum“ in the old Town hall'

          },
          {
            small: '../../assets/img/district/maison-la-fournaise.jpg',
            medium: '../../assets/img/district/maison-la-fournaise.jpg',
            big: '../../assets/img/district/maison-la-fournaise.jpg',
            description: 'Restaurant ”Maison de la Fournaise“'

          },
          {
            small: '../../assets/img/district/la-patio-shopping.jpg',
            medium: '../../assets/img/district/la-patio-shopping.jpg',
            big: '../../assets/img/district/la-patio-shopping.jpg',
            description: '”La Patio“ shopping center'

          },
          {
            small: '../../assets/img/district/chateau-malmaison.jpg',
            medium: '../../assets/img/district/chateau-malmaison.jpg',
            big: '../../assets/img/district/chateau-malmaison.jpg',
            description: 'Château de Malmaison'

          },
          {
            small: '../../assets/img/district/green-district.jpg',
            medium: '../../assets/img/district/green-district.jpg',
            big: '../../assets/img/district/green-district.jpg',
            description: 'A green district'

          },
          {
            small: '../../assets/img/district/the-duke.jpg',
            medium: '../../assets/img/district/the-duke.jpg',
            big: '../../assets/img/district/the-duke.jpg',
            description: 'Restaurant ”The Duke“'

          },
          {
            small: '../../assets/img/district/banks-seine.jpg',
            medium: '../../assets/img/district/banks-seine.jpg',
            big: '../../assets/img/district/banks-seine.jpg',
            description: 'Banks of the Seine'

          },
          {
            small: '../../assets/img/district/impressionist-park.jpg',
            medium: '../../assets/img/district/impressionist-park.jpg',
            big: '../../assets/img/district/impressionist-park.jpg',
            description: 'Impressionist’s park'

          },
          {
            small: '../../assets/img/district/rives-la-courtille.jpg',
            medium: '../../assets/img/district/rives-la-courtille.jpg',
            big: '../../assets/img/district/rives-la-courtille.jpg',
            description: 'Restaurant “Les rives de la courtille”'

          },
          {
            small: '../../assets/img/district/park-friendship.jpg',
            medium: '../../assets/img/district/park-friendship.jpg',
            big: '../../assets/img/district/park-friendship.jpg',
            description: 'Park of the friendship'

          }
        ];

      } else if (this.translate.currentLang === 'fr') {
        this.titleService.setTitle('Voyager - Un quartier d\'affaire au coeur de Rueil-Malmaison');
        this.metaService.updateTag({
          name: 'description',
          content: 'Rueil Malmaison est un quartier d\'affaires qui accueillent les entreprises du CAC40. Le quartier s\'anime à travers des espaces culturels et de nombreux restaurants, le tout entouré d\'espaces verts. '
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Rueil-Malmaison, quartier des affaires, entreprises, CAC40, restaurants, culture'
        });

        this.slides = [
          {
            url: '../../assets/img/district/jogging.jpg',
            description: 'Courir sur les bords de Seine'
          },
          {
            url: '../../assets/img/district/old-town-hall.jpg',
            description: '”musée d\'Histoire locale“ dans l\'ancienne mairie'
          },
          {
            url: '../../assets/img/district/maison-la-fournaise.jpg',
            description: 'Restaurant ”Maison de la Fournaise“'
          },
          {
            url: '../../assets/img/district/la-patio-shopping.jpg',
            description: 'Centre commercial ”la patio“'
          },
          {
            url: '../../assets/img/district/chateau-malmaison.jpg',
            description: 'Château de Malmaison'
          },
          {
            url: '../../assets/img/district/green-district.jpg',
            description: 'Un quartier vert'
          },
          {
            url: '../../assets/img/district/the-duke.jpg',
            description: 'Restaurant ”The Duke“'
          },
          {
            url: '../../assets/img/district/banks-seine.jpg',
            description: 'Les bords de Seine'
          },
          {
            url: '../../assets/img/district/impressionist-park.jpg',
            description: 'Le Parc des Impressionnistes'
          },
          {
            url: '../../assets/img/district/rives-la-courtille.jpg',
            description: 'Restaurant “Les rives de la courtille”'
          },
          {
            url: '../../assets/img/district/park-friendship.jpg',
            description: 'Parc de l\'amitié'
          }
        ];

        this.galleryImages = [
          {
            small: '../../assets/img/district/jogging.jpg',
            medium: '../../assets/img/district/jogging.jpg',
            big: '../../assets/img/district/jogging.jpg',
            description: 'Courir sur les bords de Seine'

          },
          {
            small: '../../assets/img/district/old-town-hall.jpg',
            medium: '../../assets/img/district/old-town-hall.jpg',
            big: '../../assets/img/district/old-town-hall.jpg',
            description: '”musée d\'Histoire locale“ dans l\'ancienne mairie'

          },
          {
            small: '../../assets/img/district/maison-la-fournaise.jpg',
            medium: '../../assets/img/district/maison-la-fournaise.jpg',
            big: '../../assets/img/district/maison-la-fournaise.jpg',
            description: 'Restaurant ”Maison de la Fournaise“'

          },
          {
            small: '../../assets/img/district/la-patio-shopping.jpg',
            medium: '../../assets/img/district/la-patio-shopping.jpg',
            big: '../../assets/img/district/la-patio-shopping.jpg',
            description: 'centre commercial ”La Patio“'

          },
          {
            small: '../../assets/img/district/chateau-malmaison.jpg',
            medium: '../../assets/img/district/chateau-malmaison.jpg',
            big: '../../assets/img/district/chateau-malmaison.jpg',
            description: 'Château de Malmaison'

          },
          {
            small: '../../assets/img/district/green-district.jpg',
            medium: '../../assets/img/district/green-district.jpg',
            big: '../../assets/img/district/green-district.jpg',
            description: 'Un quartier vert'

          },
          {
            small: '../../assets/img/district/the-duke.jpg',
            medium: '../../assets/img/district/the-duke.jpg',
            big: '../../assets/img/district/the-duke.jpg',
            description: 'Restaurant ”The Duke“'

          },
          {
            small: '../../assets/img/district/banks-seine.jpg',
            medium: '../../assets/img/district/banks-seine.jpg',
            big: '../../assets/img/district/banks-seine.jpg',
            description: 'Les bords de Seine'

          },
          {
            small: '../../assets/img/district/impressionist-park.jpg',
            medium: '../../assets/img/district/impressionist-park.jpg',
            big: '../../assets/img/district/impressionist-park.jpg',
            description: 'Parc des Impressionnistes'

          },
          {
            small: '../../assets/img/district/rives-la-courtille.jpg',
            medium: '../../assets/img/district/rives-la-courtille.jpg',
            big: '../../assets/img/district/rives-la-courtille.jpg',
            description: 'Restaurant “Les rives de la courtille”'

          },
          {
            small: '../../assets/img/district/park-friendship.jpg',
            medium: '../../assets/img/district/park-friendship.jpg',
            big: '../../assets/img/district/park-friendship.jpg',
            description: 'Parc de l\'amitié'

          }
        ];
      }
    });

    this.galleryOptions = [
      { 'image': false, 'thumbnails': false, 'width': '0px', 'height': '0px', 'previewInfinityMove': true, 'previewFullscreen': true, 'previewCloseOnClick': true, 'previewKeyboardNavigation': true }
    ];

  }

  openPreview(index): void {
    this.districtGallery.openPreview(index);
  }

  openMap(map: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      map,
      Object.assign({}, this.config, { class: 'district-modal modal-lg' })
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/district/district.component.ts